let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i4UPb")).then(() => parcelRequire('7sS8E'));